import React, {useCallback, useEffect, useState} from 'react';
import StyledRadioGroup from "../components/StyledRadioGroup";

import StyledTextField from "../components/StyledTextField";
import {numbersOnly} from "../data/inputFormattingFunctions";

const genderOptions = [
    {label: "Mann", value: "man"},
    {label: "Kvinne", value: "woman"},
    {label: "Annet", value: "other"}
];

const Personalia = ({ data, setField, setNextPageDisabled }) => {
    const { name, ssn, email, address, city, zip, phone, emailVerification, gender } = data.personalia;

    const updateName = useCallback(newVal => {
        setField("name", newVal);
    }, [setField]);

    const updateSsn = useCallback(newVal => {
        setField("ssn", newVal);
    }, [setField]);

    const updateEmail = useCallback(newVal => {
        setField("email", newVal);
    }, [setField]);

    const updateEmailVerification = useCallback(newVal => {
        setField("emailVerification", newVal);
    }, [setField]);

    const updateAddress = useCallback(newVal => {
        setField("address", newVal);
    }, [setField]);

    const updateCity = useCallback(newVal => {
        setField("city", newVal);
    }, [setField]);

    const updateZip = useCallback(newVal => {
        setField("zip", newVal);
    }, [setField]);

    const updatePhone = useCallback(newVal => {
        setField("phone", newVal);
    }, [setField]);

    const updateGender = useCallback(newVal => {
        setField("gender", newVal);
    }, [setField]);

    // Validate inputs
    const [nameError, setNameError] = useState(null);
    const [ssnError, setSsnError] = useState(null);
    const [emailError, setEmailError] = useState(null);
    const [emailVerificationError, setEmailVerificationError] = useState(null);
    const [addressError, setAddressError] = useState(null);
    const [cityError, setCityError] = useState(null);
    const [zipError, setZipError] = useState(null);
    const [phoneError, setPhoneError] = useState(null);

    useEffect(() => {
        let nextDisabled = false;

        // validate name
        if (name === null){
            setNameError(null);
            nextDisabled = true;
        } else if (name.length < 4){
            setNameError("Må inneholde minst 4 bokstaver.");
            nextDisabled = true;
        } else if (name.length > 300) {
            setNameError("Maks 300 bokstaver.")
            nextDisabled = true;
        } else {
            setNameError(null);
        }

        // validate ssn
        if (ssn === null){
            setSsnError(null);
            nextDisabled = true;
        } else if (ssn.length !== 11){
            setSsnError("Skal være 11 siffer.")
            nextDisabled = true;
        } else {
            setSsnError(null);
        }

        // Validate address
        if (address === null){
            setAddressError(null);
            nextDisabled = true;
        } else if (address.length < 3){
            setAddressError("Minst 3 bokstaver.");
            nextDisabled = true;
        } else {
            setAddressError(null);
        }

        // Validate City
        if (city === null){
            setCityError(null);
            nextDisabled = true;
        } else if (city.length < 3){
            setCityError("Minst 3 bokstaver");
            nextDisabled = true;
        } else {
            setCityError(null);
        }

        // Validate zip
        if (zip === null){
            setZipError(null);
            nextDisabled = true;
        } else if (zip.length !== 4) {
            setZipError("Skal være 4 siffer");
            nextDisabled = true;
        } else {
            setZipError(null);
        }

        // Validate phone
        if (phone === null){
            setPhoneError(null);
            nextDisabled = true;
        } else if (phone.length < 6){
            setPhoneError("Minst 7 siffer.");
            nextDisabled = true;
        } else {
            setPhoneError(null);
        }

        // validate email
        if (email == null){
            setEmailError(null);
            nextDisabled = true;
        } else if (email.length < 6){
            setEmailError("Ugyldig e-postadresse.")
            nextDisabled = true;
        } else {
            setEmailError(null);
        }

        // validate email validation
        if (emailVerification == null){
            setEmailVerificationError(null);
            nextDisabled = true;
        } else if (emailVerification !== email){
            setEmailVerificationError("E-postadressene er ikke like.");
            nextDisabled = true;
        } else {
            setEmailVerificationError(null);
        }

        setNextPageDisabled(nextDisabled);
    }, [name, ssn, address, city, zip, phone, email, emailVerification, setNextPageDisabled])

    return(
        <div>
            <StyledTextField
                onChange={updateName}
                type={"text"}
                value={name || ""}
                label={"Ditt navn"}
                error={nameError}
            />
            <StyledTextField
                onChange={updateSsn}
                type={"text"}
                value={ssn || ""}
                label={"Ditt fødselsnummer"}
                error={ssnError}
                formatOnBlur={numbersOnly}
            />
            <StyledTextField
                onChange={updateAddress}
                type={"text"}
                value={address || ""}
                label={"Postadresse"}
                error={addressError}
            />
            <StyledTextField
                onChange={updateZip}
                type={"text"}
                value={zip || ""}
                label={"Postnummer"}
                error={zipError}
                formatOnBlur={numbersOnly}
            />
            <StyledTextField
                onChange={updateCity}
                type={"text"}
                value={city || ""}
                label={"Poststed"}
                error={cityError}
            />
            <StyledTextField
                onChange={updateEmail}
                type={"text"}
                value={email || ""}
                label={"E-post"}
                error={emailError}
            />
            <StyledTextField
                onChange={updateEmailVerification}
                type={"text"}
                value={emailVerification || ""}
                label={"Gjenta e-post"}
                error={emailVerificationError}
            />
            <StyledTextField
                onChange={updatePhone}
                type={"text"}
                value={phone || ""}
                label={"Telefonnummer"}
                error={phoneError}
            />
            <br/>
            <StyledRadioGroup
                onChange={updateGender}
                options={genderOptions}
                heading={"Kjønn"}
                value={gender}
            />
        </div>
    )
}

export default Personalia;